module.exports = __webpack_public_path__ + "static/media/25-6.29143580.mp3";